import React from "react";
import {Row, Col, BackTop} from "antd";
import { template, setLocalStorage } from "@reco-m/core";
import { ViewComponent, Banner } from "@reco-w/core-ui";
import { Namespaces, promoteModel } from "@reco-w/merchants-models";
import SwiperCore, { Autoplay, Navigation, Pagination, Thumbs } from "swiper";
SwiperCore.use([Autoplay, Navigation, Pagination, Thumbs]);

// import CountUp from "../../../assets/js/count";

import { R2040ArticleList } from "src/apps/common/r2040.article.list";
import { Consulting } from "src/apps/consulting/consulting";

declare class CountUp {
    constructor(...p: any[]);

    start(): void;
}

export namespace Promote {
    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, promoteModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.promote;

        componentMount() {
            window.scroll(0, 0);
            setLocalStorage("selectedMenu", `/promote`);
        }
        componentDidMount() {
            this.dispatch("input", { newsSlides: 2, newsSpace: 60 });
            this.scalePage();
            $(window).resize(() => {
                return this.scalePage();
            });

            // 数字滚动
            let options = {
                useEasing: true,
                useGrouping: true,
                separator: ",",
                decimal: ".",
                prefix: "",
                suffix: "",
            };
            let demo = new CountUp("num0", 0, 100, 0, 2.5, options);
            let demo2 = new CountUp("num1", 0, 5000, 0, 2.5, options);
            let demo3 = new CountUp("num2", 0, 10, 0, 2.5, options);
            let demo4 = new CountUp("num3", 0, 500, 0, 2.5, options);
            $(window).on("scroll", function () {
                if (($(window).scrollTop() as any) >= 300) {
                    demo.start();
                    demo2.start();
                    demo3.start();
                    demo4.start();
                }
            });
            $(".container-scrollable").on("scroll", function () {
                if (($(".container-scrollable").scrollTop() as any) >= 300) {
                    demo.start();
                    demo2.start();
                    demo3.start();
                    demo4.start();
                }
            });
        }

        scalePage() {
            const width = document.documentElement.clientWidth;
            if (width < 1200) {
                this.dispatch("input", { newsSlides: 1, newsSpace: 0 });
            } else {
                this.dispatch("input", { newsSlides: 2, newsSpace: 60 });
            }
        }

        renderFiveLarge() {
            const fiveData = [
                {
                    icon: "icon iconhuodong2",
                    name: "问题一",
                    desc: "活动效果不佳",
                },
                {
                    icon: "icon iconziyuan11",
                    name: "问题二",
                    desc: "企业资源不足",
                },
                {
                    icon: "icon iconzhiliang",
                    name: "问题三",
                    desc: "企业质量不足",
                },
                {
                    icon: "icon iconzhihang",
                    name: "问题四",
                    desc: "活动执行困难",
                },
                {
                    icon: "icon icongenjin",
                    name: "问题五",
                    desc: "活动缺乏跟进",
                },
            ];
            return (
                <div className="block-content">
                    <div className="container">
                        <div className="second-title">
                            <span>解决五大问题</span>
                        </div>
                        <Row className="five-large-grid">
                            {fiveData.map((item, i) => {
                                return (
                                    <Col key={i}>
                                        <div className="five-large-item">
                                            <div className="five-large-icon">
                                                <i className={item.icon} />
                                            </div>
                                            <div className="size-16 gray-three-color mt15">{item.name}</div>
                                            <div className="size-16 gray-one-color mt10 five-large-name">{item.desc}</div>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </div>
            );
        }

        renderSuperiority() {
            const xmData = [
                {
                    icon: "icon icontuijian",
                    number: 100,
                    unit: "场",
                    text: "招商推荐",
                },
                {
                    icon: "icon iconduijie1",
                    number: 5000,
                    unit: "家",
                    text: "企业对接",
                },
                {
                    icon: "icon iconziyuanchi",
                    number: 10,
                    unit: "万个",
                    text: "项目资源池",
                },
                {
                    icon: "icon iconhezuo",
                    number: 500,
                    unit: "家",
                    text: "政府园区合作",
                },
            ];
            return (
                <div className="block-content superiority-content">
                    <div className="container">
                        <div className="second-title white-color">
                            <span>我们的优势</span>
                        </div>
                        <Row className="mt10 number-tj line-number-tj">
                            {xmData.map((item, i) => {
                                return (
                                    <Col xs={12} sm={12} md={6} key={i}>
                                        <div className="company-grid-item">
                                            <i className={"size-55 primary-color " + item.icon} />
                                            <Row align="middle" justify="center" className="mt25">
                                                <div className="size-42 white-color" id={"num" + i}>
                                                    {+item.number}
                                                </div>
                                                <div className="ml5">
                                                    <div className="primary-color size-20 bold">+</div>
                                                    <div className="white-color mt3">{item.unit}</div>
                                                </div>
                                            </Row>
                                            <div className="size-20 white-color mt20">{item.text}</div>
                                        </div>
                                    </Col>
                                );
                            })}
                        </Row>
                    </div>
                </div>
            );
        }

        renderFlow() {
            return (
                <div className="block-content">
                    <div className="second-title">
                        <span>服务流程</span>
                    </div>
                    <div className="flow-box">
                        <div className="container">
                            <img src="assets/images/second/lc-img.png" />
                        </div>
                    </div>
                </div>
            );
        }

        renderAnli() {
            return (
                <div className="block-content" style={{ backgroundColor: "#f8f8f8" }}>
                    <div className="container">
                        <div className="second-title">
                            <span>最新案例</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            caseType: 3,
                            tagIds: ["887893341236019200"],
                        } as any)}
                        {/* <div className="anli-swiper-box">
                            <div className="swiper-button-prev" />
                            <div className="swiper-button-next" />
                            <Swiper
                                slidesPerView={1}
                                className="anli-swiper gray mt10"
                                style={{ height: 580 }}
                                pagination={false}
                                navigation={{
                                    nextEl: '.anli-swiper-box .swiper-button-next',
                                    prevEl: '.anli-swiper-box .swiper-button-prev'
                                }}
                                spaceBetween={10}
                            >
                                <SwiperSlide>
                                    <Row className="anli-swiper-item">
                                        <ImageAuto.Component src="assets/images/second/anli-img5.jpg" width="70%" height="490px" radius={0} />
                                        <div className="anli-swiper-write">
                                            <Paragraph ellipsis={{rows: 2, expandable: false}} className="mb0 size-22 white-color mt30">
                                                数字经济（金融科技）产业发展成都推介会成功举办
                                            </Paragraph>
                                            <Paragraph ellipsis={{rows: 4, expandable: false}} className="mb0 size-16 white6 mt40 anli-swiper-desc">
                                                瑞谷云企圆满举办招商数字经济（金融科技）
                                                产业发展成都推介会。西湖区副区长韩斌带队，
                                                西溪谷管委会、区投促局、区商务局（金融办）
                                                相关负责人参加。
                                            </Paragraph>
                                            <div className="anli-swiper-date">
                                                2022.10.16
                                            </div>
                                            <div className="swiper-number">01</div>
                                        </div>
                                    </Row>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <Row className="anli-swiper-item">
                                        <ImageAuto.Component src="assets/images/second/anli-img5.jpg" width="70%" height="490px" radius={0} />
                                        <div className="anli-swiper-write">
                                            <Paragraph ellipsis={{rows: 2, expandable: false}} className="mb0 size-22 white-color mt30">
                                                数字经济（金融科技）产业发展成都推介会成功举办
                                            </Paragraph>
                                            <Paragraph ellipsis={{rows: 4, expandable: false}} className="mb0 size-16 white6 mt40 anli-swiper-desc">
                                                瑞谷云企圆满举办招商数字经济（金融科技）
                                                产业发展成都推介会。西湖区副区长韩斌带队，
                                                西溪谷管委会、区投促局、区商务局（金融办）
                                                相关负责人参加。
                                            </Paragraph>
                                            <div className="anli-swiper-date">
                                                2022.10.16
                                            </div>
                                            <div className="swiper-number">02</div>
                                        </div>
                                    </Row>
                                </SwiperSlide>
                            </Swiper>
                        </div> */}
                    </div>
                </div>
            );
        }
        renderNews() {
            // const { state } = this.props,
            //     newsSlides = state!.newsSlides,
            //     newsSpace = state!.newsSpace;
            // const newsData = [
            //     {
            //         imgUrl: "assets/images/second/zs-img1.jpg",
            //         title: "【瑞谷云企选址系列 34】一家拥有多项专利的高新技术防",
            //         day: "10",
            //         date: "2022-08",
            //         desc: "郑州名匠网络科技有限公司是一家集游戏高感染力 视觉设计、游戏开发与发行等业务为一体的互联网高增长科技型",
            //     },
            //     {
            //         imgUrl: "assets/images/second/zs-img2.jpg",
            //         title: "【对接考察】杭州市投促局领导莅临瑞谷云企考察参观",
            //         day: "03",
            //         date: "2022-08",
            //         desc: "8月3日下午，杭州市投资促进局党组书记、局长王越剑，杭州市投资促进局副局长蔡善强，杭州市投资促进局投促",
            //     },
            //     {
            //         imgUrl: "assets/images/second/zs-img1.jpg",
            //         title: "【瑞谷云企选址系列 34】一家拥有多项专利的高新技术防",
            //         day: "10",
            //         date: "2022-08",
            //         desc: "郑州名匠网络科技有限公司是一家集游戏高感染力 视觉设计、游戏开发与发行等业务为一体的互联网高增长科技型",
            //     },
            //     {
            //         imgUrl: "assets/images/second/zs-img2.jpg",
            //         title: "【对接考察】杭州市投促局领导莅临瑞谷云企考察参观",
            //         day: "03",
            //         date: "2022-08",
            //         desc: "8月3日下午，杭州市投资促进局党组书记、局长王越剑，杭州市投资促进局副局长蔡善强，杭州市投资促进局投促",
            //     },
            // ];
            return (
                <div className="block-content">
                    <div className="container">
                        <div className="second-title">
                            <span>招商动态</span>
                        </div>
                        {this.renderEmbeddedView(R2040ArticleList.Page, {
                            tagIds: ["887893341269573632"],
                        } as any)}
                        {/* <div className="news-swiper-box">
                            <Swiper
                                slidesPerView={newsSlides}
                                className="news-swiper gray mt10"
                                style={{ height: 580 }}
                                pagination={true}
                                spaceBetween={newsSpace}
                            // autoplay={{
                            //     delay: 3000,
                            //     disableOnInteraction: false,  //false: 鼠标操作屏幕后继续自动滚屏
                            // }}
                            >
                                {newsData.map((item, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="news-swiper-item">
                                                <div className="news-img">
                                                    <ImageAuto.Component src={item.imgUrl} width="100%" height="100%" radius={0} />
                                                    <div className="position-date">
                                                        <span>{item.day}</span>
                                                        {item.date}
                                                    </div>
                                                </div>
                                                <div className="pg20">
                                                    <Paragraph ellipsis={{ rows: 1, expandable: false }} className="mb0 size-18 gray-one-color">
                                                        {item.title}
                                                    </Paragraph>
                                                    <Paragraph ellipsis={{ rows: 2, expandable: false }} className="mb0 size-14 gray-three-color mt20">
                                                        {item.desc}
                                                    </Paragraph>
                                                    <div className="mt30">
                                                        <span className="list-arrow" />
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                            </Swiper>
                        </div> */}
                    </div>
                </div>
            );
        }

        renderConsult() {
            return <Consulting.Page renderType={1} orderCode="guanwcyzs"></Consulting.Page>;
            // return (
            //     <div className="block-content consult-content">
            //         <div className="container">
            //             <div className="second-title line-no white-color">
            //                 <span>立即咨询定制方案</span>
            //             </div>
            //             <div className="consult-form">
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的姓名" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的单位" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Input placeholder="请输入您的联系方式" />
            //                 </div>
            //                 <div className="consult-form-item">
            //                     <Button type="primary" ghost block shape="round">立即咨询</Button>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // )
        }

        renderBody() {
            return (
                <>
                    <div className="content">
                        <Banner.Component
                            extraClass="large"
                            bimg="assets/images/banner/tj-banner.jpg"
                            cimg=""
                            text={
                                <div className="home-banner-text">
                                    <div className="banner-text-name1"><img src="assets/images/banner/tj-text.png" /></div>
                                    <div className="banner-text-name2 mt25">驱动区域经济 加速招才引资</div>
                                </div>
                            }
                        />
                        {this.renderFiveLarge()}
                        {this.renderSuperiority()}
                        {this.renderFlow()}
                        {this.renderAnli()}
                        {this.renderNews()}
                        {this.renderConsult()}

                        <div className="scoll-top">
                            <BackTop visibilityHeight={50} />
                        </div>
                    </div>
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.promote]);
}
